<template>
  <b-modal
      id="modal-item-playlist"
      :title="`افزودن رسانه به ${playlist ? playlist.title : 'پلی‌لیست'}`"
      hide-footer
      header-bg-variant="light"
      @hidden="resetForm"
  >
    <b-form @submit.prevent="submit">
      <!-- File Selection -->
      <b-form-group label="رسانه" label-for="fileEntryId">
        <b-input-group>
          <b-form-input
              id="fileEntryId"
              v-model="selectedFileTitle"
              placeholder="رسانه را انتخاب کنید"
              readonly
          />
          <b-input-group-append>
            <b-button variant="primary" @click="openMediaLibrary">
              <i class="fas fa-folder-open"></i> انتخاب
            </b-button>
            <b-button
                v-if="selectedFileId"
                variant="outline-danger"
                @click="clearSelection"
            >
              <feather-icon icon="TrashIcon"></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <small class="text-muted">
          برای انتخاب رسانه از کتابخانه رسانه استفاده کنید.
        </small>
      </b-form-group>

      <b-form-group label="ترتیب" label-for="sortOrder">
        <b-form-input
            id="sortOrder"
            v-model="form.sortOrder"
            type="number"
            placeholder="۰"
        />
      </b-form-group>

      <div class="d-flex justify-content-end gap-2">

        <b-button variant="primary" type="submit" class="ml-2" :disabled="submitting || !selectedFileId">
          <i class="fas fa-spinner fa-spin" v-if="submitting"></i>
          افزودن
        </b-button>
      </div>
    </b-form>

    <!-- Media Library Dialog -->
    <MediaLibraryDialog
        v-model="showMediaLibrary"
        :multiple="false"
        @select="onMediaSelected"
    />
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
import { PlaylistAddItemRequest } from '@/libs/Api/Playlist'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import MediaLibraryDialog from "@/views/apps/library/MediaLibraryDialog.vue";

export default {
  name: 'AddItemModal',
  components: {
    MediaLibraryDialog,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    playlist: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      submitting: false,
      showMediaLibrary: false,
      form: {
        fileEntryId: null,
        sortOrder: 0
      },
      selectedFileId: null,
      selectedFileTitle: ''
    }
  },
  methods: {
    show() {
      this.visible = true
      this.selectedFileId = null
      this.selectedFileTitle = ''
      this.form.fileEntryId = null
      this.form.sortOrder = 0
    },
    hide() {
      this.visible = false
    },
    resetForm() {
      this.selectedFileId = null
      this.selectedFileTitle = ''
      this.form.fileEntryId = null
      this.form.sortOrder = 0
      this.submitting = false
      this.showMediaLibrary = false
    },
    openMediaLibrary() {
      this.showMediaLibrary = true
    },
    onMediaSelected({ ids, files }) {
      if (ids.length > 0) {
        const file = files[0]
        this.selectedFileId = file.id
        this.selectedFileTitle = file.title || file.originalName || 'بدون عنوان'
        this.form.fileEntryId = file.id
      }
      this.showMediaLibrary = false
    },
    clearSelection() {
      this.selectedFileId = null
      this.selectedFileTitle = ''
      this.form.fileEntryId = null
    },
    submit() {
      if (!this.form.fileEntryId) {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'خطا',
            icon: 'XIcon',
            variant: 'warning',
            text: 'لطفاً یک رسانه انتخاب کنید.'
          }
        })
        return
      }

      if (!this.playlist) return

      this.submitting = true
      const data = {
        playlistId: this.playlist.id,
        fileEntryId: parseInt(this.form.fileEntryId),
        sortOrder: parseInt(this.form.sortOrder) || 0
      }

      const request = new PlaylistAddItemRequest(this)
      request.setParams(data)
      request.fetch(
          (content) => {
            this.submitting = false
            this.hide()
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'رسانه با موفقیت به پلی‌لیست اضافه شد.'
              }
            })
            this.$emit('added', content)
            this.resetForm()
            this.$bvModal.hide('modal-item-playlist')
          },
          (error) => {
            this.submitting = false
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'خطا',
                icon: 'XIcon',
                variant: 'danger',
                text: error.message || 'مشکل در افزودن ویدیو'
              }
            })
          }
      )
    }
  }
}
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}
</style>
